import { enUS, sv, de, fr, es, it, pl, da, nb, fi } from 'date-fns/locale';

export const dateLocales: Record<string, Locale> = {
  en: enUS,
  sv,
  de,
  fr,
  es,
  it,
  pl,
  da,
  nb,
  fi,
};
